import api from "../services/api";

import { IRevendedor, ISearchRequest, ISearchResponse } from "../interfaces";
import { AxiosResponse } from "axios";

export interface IResellerListModel {
    id?: string;
    status: number;
    data: string;
    devedor: number;
    cpf: string;
    nome: string;
    representante: string;
    representanteId: string;
    cidade: string;
    uf: string;
    consulta: string;
}

interface ITransferPutModel {
    representanteId?: string;
}

interface ITransferRequest {
    id?: string;
    transferPutModel: ITransferPutModel;
}

interface ITransferResponse {
    revendedor: IRevendedor;
    message: string;
}

interface IResellerResponseModel {
    revendedor: IRevendedor;
    message: string;
}

class ResellersRepository {

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<IResellerListModel>> => {
        const response = await api.get<ISearchResponse<IResellerListModel>>("revendedor", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public Inactive = async (id: string): Promise<AxiosResponse<IResellerResponseModel>> => {
        const response = await api.post<IResellerResponseModel>(`revendedor/${id}/inactive`);
        return response;
    }

    public GetById = async (id: string): Promise<IRevendedor> => {
        const response = await api.get<IRevendedor>(`revendedor/${id}`);

        return response.data;
    }

    public GetByCpf = async (cpf: string): Promise<IRevendedor> => {
        const response = await api.get<IRevendedor>(`revendedor/cpf/${cpf}`);
        return response.data;
    }

    public Transfer = async ({ id, transferPutModel }: ITransferRequest): Promise<AxiosResponse<ITransferResponse>> => {
        const response = await api.put<ITransferResponse>(`revendedor/${id}/transfer`, transferPutModel);
        return response
    }
}
const resellersRepository = new ResellersRepository();
export default resellersRepository;
